import { FormControl, InputLabel, MenuItem, Select, type SelectChangeEvent } from '@mui/material';

import type { NodeItem } from '@models/flows';
import { useSettingsQuery } from '@features/setting/queries';

type NodeConfigProps = {
  currentNode: NodeItem;
  onChange: (data: NodeItem) => void;
};

function SettingsNodeConfiguration({ currentNode, onChange }: NodeConfigProps) {
  const { data: settings } = useSettingsQuery();
  const SETTINGS_OPTIONS = (settings ?? [])
    .filter((c) => c.setting.metadata?.allowed_for_settings_node)
    .map((s) => ({ value: s.id, label: s.slug }));

  if (!currentNode) return null;

  const handleChange = (event: SelectChangeEvent<string>) => {
    const selected = SETTINGS_OPTIONS.find((opt) => opt.value === event.target.value);
    if (!selected) return;

    onChange({
      ...currentNode,
      settingId: selected.value,
      label: selected.label,
    });
  };

  return (
    <FormControl fullWidth>
      <InputLabel id="settings-node-label">Setting</InputLabel>
      <Select
        labelId="settings-node-label"
        value={currentNode.settingId || ''}
        label="Setting"
        onChange={handleChange}
        sx={{ width: 300 }}
        MenuProps={{ disablePortal: true }}>
        {SETTINGS_OPTIONS.map(({ value, label }) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default SettingsNodeConfiguration;
